import { GroupSecurity } from '@quromedical/fhir-common';
import { z } from 'zod';
import { DisplayReferenceSchema, UUIDSchema } from '../domain/models';
import { PartialPractitionerSchema } from '../practitioner/schema';
import type { WithId } from '../types';
import {
  ThemeSchema,
  UserPreferenceWardSchema,
} from '../user-preference/schema';

export const PreferenceSchema = z.object({
  theme: ThemeSchema,
  // TODO: Uncomment when preferences are deleted on fhir gateway and insight is updated
  // wards: WardSchema.array().optional(),
});

export const UpdateHospitalSettingsSchema = z.object({
  wards: UUIDSchema.array().min(1),
});

export const PermissionSchema = z.nativeEnum(GroupSecurity);

export const ProfileSchema = z.object({
  id: UUIDSchema,

  permissions: PermissionSchema.array(),
  groups: DisplayReferenceSchema.array(),
  organizations: DisplayReferenceSchema.array(),
  preference: PreferenceSchema.partial(),
});

export const UserSchema = z.object({
  practitioner: PartialPractitionerSchema,
  preference: PreferenceSchema.partial(),
  groups: DisplayReferenceSchema.array(),
  organizations: DisplayReferenceSchema.array(),
  permissions: PermissionSchema.array(),
  wards: UserPreferenceWardSchema.array(),
});

export const UserWithIdSchema = UserSchema.extend({
  id: UUIDSchema,
});

export type User = z.infer<typeof UserSchema>;
export type UserPreference = z.infer<typeof PreferenceSchema>;

export type UserMeRequest = undefined;
export type UserMeResponse = WithId<User>;

export type UserUpdatePreferenceRequest = Required<UserPreference>;
export type UserUpdatePreferenceResponse = Partial<UserPreference>;
export type UserUpdateHospitalSettingsRequest = z.infer<
  typeof UpdateHospitalSettingsSchema
>;
export type UserProfile = z.infer<typeof ProfileSchema>;
